module.exports = __webpack_public_path__ + "img/9.120.0-3-mobile.078cf27f.png";